let csvw_url = "https://www.csvw.com";

let template60 = [
  {
    imgurl: "/u/cms/www/202108/3020453973PY.jpg",
    imgurlMobile: "/u/cms/www/202108/30204638192h.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204539n7w9.jpg",
    imgurlMobile: "/u/cms/www/202108/302046385J9B.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045397T94.jpg",
    imgurlMobile: "/u/cms/www/202108/30204638Z097.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045396let.jpg",
    imgurlMobile: "/u/cms/www/202108/30204640u9t5.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045392Bn1.jpg",
    imgurlMobile: "/u/cms/www/202108/30204640N0JX.jpg",
  },
  // {
  //   imgurl: "/u/cms/www/202108/302045403Bw8.jpg",
  //   imgurlMobile: "/u/cms/www/202108/302046415Y5e.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202108/30204539xr82.jpg",
  //   imgurlMobile: "/u/cms/www/202108/30204643JSPu.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202108/302045400j47.jpg",
  //   imgurlMobile: "/u/cms/www/202108/30204642eI19.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202108/3020454037f4.jpg",
  //   imgurlMobile: "/u/cms/www/202108/30204643p182.jpg",
  // },
  // {
  //   imgurl: "/u/cms/www/202108/30204541Jz85.jpg",
  //   imgurlMobile: "/u/cms/www/202108/30204647Ra6E.jpg",
  // },
  {
    imgurl: "/u/cms/www/202108/302045401lVk.jpg",
    imgurlMobile: "/u/cms/www/202108/30204647j9r3.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204540g5fR.jpg",
    imgurlMobile: "/u/cms/www/202108/30204644x3PW.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204541uQ6y.jpg",
    imgurlMobile: "/u/cms/www/202108/3020464515qV.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045407w84.jpg",
    imgurlMobile: "/u/cms/www/202108/302046467J4B.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204540GR9C.jpg",
    imgurlMobile: "/u/cms/www/202108/3020464641F8.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045400bJD.jpg",
    imgurlMobile: "/u/cms/www/202108/302046473817.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045411Wj7.jpg",
    imgurlMobile: "/u/cms/www/202108/30204648764a.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204541mybE.jpg",
    imgurlMobile: "/u/cms/www/202108/302046488Qkc.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045412SgB.jpg",
    imgurlMobile: "/u/cms/www/202108/302046506l93.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204541Ns1T.jpg",
    imgurlMobile: "/u/cms/www/202108/302046493kxx.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045433uPQ.jpg",
    imgurlMobile: "/u/cms/www/202108/30204650415v.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204541t3K7.jpg",
    imgurlMobile: "/u/cms/www/202108/302046514v90.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045433KBa.jpg",
    imgurlMobile: "/u/cms/www/202108/30204652Y22D.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204542l6yG.jpg",
    imgurlMobile: "/u/cms/www/202108/30204652JC4a.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204542Sd4E.jpg",
    imgurlMobile: "/u/cms/www/202108/30204656b1EN.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204542k783.jpg",
    imgurlMobile: "/u/cms/www/202108/3020465358XR.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204542m15S.jpg",
    imgurlMobile: "/u/cms/www/202108/302046530669.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/3020454445rq.jpg",
    imgurlMobile: "/u/cms/www/202108/30204655b439.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204543E99r.jpg",
    imgurlMobile: "/u/cms/www/202108/30204654LI4w.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/3020454344yR.jpg",
    imgurlMobile: "/u/cms/www/202108/30204656343v.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204543MUf7.jpg",
    imgurlMobile: "/u/cms/www/202108/302046577785.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/3020454390XE.jpg",
    imgurlMobile: "/u/cms/www/202108/30204701c625.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204543457g.jpg",
    imgurlMobile: "/u/cms/www/202108/30204657195S.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204543sw25.jpg",
    imgurlMobile: "/u/cms/www/202108/30204658Xrdj.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204544dw9L.jpg",
    imgurlMobile: "/u/cms/www/202108/30204659C1Cz.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045443hyk.jpg",
    imgurlMobile: "/u/cms/www/202108/30204701bQ06.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204544PW20.jpg",
    imgurlMobile: "/u/cms/www/202108/302047039M8X.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204544n7oo.jpg",
    imgurlMobile: "/u/cms/www/202108/302047050Qh6.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204544Hi6K.jpg",
    imgurlMobile: "/u/cms/www/202108/30204703V6S6.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204545HeD7.jpg",
    imgurlMobile: "/u/cms/www/202108/3020471271b3.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045457A6E.jpg",
    imgurlMobile: "/u/cms/www/202108/30204707Xd1N.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204544q61s.jpg",
    imgurlMobile: "/u/cms/www/202108/30204709564c.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204545v98J.jpg",
    imgurlMobile: "/u/cms/www/202108/30204710X3bc.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045463hL0.jpg",
    imgurlMobile: "/u/cms/www/202108/30204715rTls.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045467qT3.jpg",
    imgurlMobile: "/u/cms/www/202108/30204715R415.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204546401y.jpg",
    imgurlMobile: "/u/cms/www/202108/302047167Rha.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204546IU53.jpg",
    imgurlMobile: "/u/cms/www/202108/30204716ENk8.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204546ZH0x.jpg",
    imgurlMobile: "/u/cms/www/202108/30204716TLY6.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045469G21.jpg",
    imgurlMobile: "/u/cms/www/202108/302047209ls9.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204546239G.jpg",
    imgurlMobile: "/u/cms/www/202108/30204718qR40.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/3020454624Y4.jpg",
    imgurlMobile: "/u/cms/www/202108/30204718637Q.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204546c8wp.jpg",
    imgurlMobile: "/u/cms/www/202108/30204719033h.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204546OnSQ.jpg",
    imgurlMobile: "/u/cms/www/202108/302047227BRK.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204546mbF8.jpg",
    imgurlMobile: "/u/cms/www/202108/302047202Sk0.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045470zWR.jpg",
    imgurlMobile: "/u/cms/www/202108/30204721EQ55.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/3020454729Cq.jpg",
    imgurlMobile: "/u/cms/www/202108/3020472314Ba.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204547g7d3.jpg",
    imgurlMobile: "/u/cms/www/202108/3020472469hj.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045472gd3.jpg",
    imgurlMobile: "/u/cms/www/202108/302047252p85.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045473W97.jpg",
    imgurlMobile: "/u/cms/www/202108/30204728B8N3.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204547543W.jpg",
    imgurlMobile: "/u/cms/www/202108/302047295w8u.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204548x936.jpg",
    imgurlMobile: "/u/cms/www/202108/302047272826.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204547GJHh.jpg",
    imgurlMobile: "/u/cms/www/202108/30204729qpV7.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204547VH1J.jpg",
    imgurlMobile: "/u/cms/www/202108/30204730v47F.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204547Ms27.jpg",
    imgurlMobile: "/u/cms/www/202108/30204731n4X2.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204548E0s3.jpg",
    imgurlMobile: "/u/cms/www/202108/30204734bb72.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204548H801.jpg",
    imgurlMobile: "/u/cms/www/202108/30204733309D.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204548uy7z.jpg",
    imgurlMobile: "/u/cms/www/202108/30204732XBx9.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204548075x.jpg",
    imgurlMobile: "/u/cms/www/202108/302047343401.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045481j9z.jpg",
    imgurlMobile: "/u/cms/www/202108/302047354OJS.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204549o321.jpg",
    imgurlMobile: "/u/cms/www/202108/30204737F13e.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045497805.jpg",
    imgurlMobile: "/u/cms/www/202108/302047351X43.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045499p2t.jpg",
    imgurlMobile: "/u/cms/www/202108/30204738b003.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045494XTM.jpg",
    imgurlMobile: "/u/cms/www/202108/302047371926.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204549346H.jpg",
    imgurlMobile: "/u/cms/www/202108/3020474277PF.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045507H7v.jpg",
    imgurlMobile: "/u/cms/www/202108/302047435s08.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204549zbpq.jpg",
    imgurlMobile: "/u/cms/www/202108/302047446441.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045499366.jpg",
    imgurlMobile: "/u/cms/www/202108/30204746609V.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204551l2oA.jpg",
    imgurlMobile: "/u/cms/www/202108/30204747d7Tt.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204550CpAY.jpg",
    imgurlMobile: "/u/cms/www/202108/302047497R9x.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204550F0J4.jpg",
    imgurlMobile: "/u/cms/www/202108/30204751O78J.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204550DOW4.jpg",
    imgurlMobile: "/u/cms/www/202108/302047523S47.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045506I87.jpg",
    imgurlMobile: "/u/cms/www/202108/30204753S387.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204551Zd45.jpg",
    imgurlMobile: "/u/cms/www/202108/302047543Zbn.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204551ZM40.jpg",
    imgurlMobile: "/u/cms/www/202108/3020475433fH.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045518N83.jpg",
    imgurlMobile: "/u/cms/www/202108/30204756L1DR.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204551Y0Ks.jpg",
    imgurlMobile: "/u/cms/www/202108/30204756bSE3.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204551z26t.jpg",
    imgurlMobile: "/u/cms/www/202108/30204756Y47J.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045514V0t.jpg",
    imgurlMobile: "/u/cms/www/202108/30204759A8FJ.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204551675C.jpg",
    imgurlMobile: "/u/cms/www/202108/302048006v57.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/3020455157p8.jpg",
    imgurlMobile: "/u/cms/www/202108/30204758553N.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045522620.jpg",
    imgurlMobile: "/u/cms/www/202108/30204759v461.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204551nZ9g.jpg",
    imgurlMobile: "/u/cms/www/202108/302048019h2h.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045510gDF.jpg",
    imgurlMobile: "/u/cms/www/202108/302048010070.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/302045519HlX.jpg",
    imgurlMobile: "/u/cms/www/202108/302048023MN3.jpg",
  },
  {
    imgurl: "/u/cms/www/202108/30204552Z3O5.jpg",
    imgurlMobile: "/u/cms/www/202108/302048035ciU.jpg",
  },
];

let template60Mobile = [
  { id: 1, imgurlMobile: "/u/cms/www/202108/3101412094K3.jpg" },
  { id: 2, imgurlMobile: "/u/cms/www/202108/31014120PDp0.jpg" },
  { id: 3, imgurlMobile: "/u/cms/www/202108/3101412001I9.jpg" },
  { id: 4, imgurlMobile: "/u/cms/www/202108/31014125363H.jpg" },
  { id: 5, imgurlMobile: "/u/cms/www/202108/3101412418t5.jpg" },
  { id: 6, imgurlMobile: "/u/cms/www/202108/310141233W3F.jpg" },
  { id: 7, imgurlMobile: "/u/cms/www/202108/31014125RUT9.jpg" },
  { id: 8, imgurlMobile: "/u/cms/www/202108/31014127o77t.jpg" },
  { id: 9, imgurlMobile: "/u/cms/www/202108/310141311kF2.jpg" },
  { id: 10, imgurlMobile: "/u/cms/www/202108/310141262ky9.jpg" },
  { id: 11, imgurlMobile: "/u/cms/www/202108/310141282dK8.jpg" },
  { id: 12, imgurlMobile: "/u/cms/www/202108/310141299R5B.jpg" },
  { id: 13, imgurlMobile: "/u/cms/www/202108/3101413122N4.jpg" },
  { id: 14, imgurlMobile: "/u/cms/www/202108/31014133N3Kr.jpg" },
  { id: 15, imgurlMobile: "/u/cms/www/202108/31014132GQ3f.jpg" },
  { id: 16, imgurlMobile: "/u/cms/www/202108/31014132q4kQ.jpg" },
  { id: 17, imgurlMobile: "/u/cms/www/202108/310141361zgk.jpg" },
  { id: 18, imgurlMobile: "/u/cms/www/202108/3101413365mh.jpg" },
  { id: 19, imgurlMobile: "/u/cms/www/202108/31014135362L.jpg" },
  { id: 20, imgurlMobile: "/u/cms/www/202108/31014135Q244.jpg" },
  { id: 21, imgurlMobile: "/u/cms/www/202108/31014139jI65.jpg" },
  { id: 22, imgurlMobile: "/u/cms/www/202108/310141366JTG.jpg" },
  { id: 23, imgurlMobile: "/u/cms/www/202108/310141373922.jpg" },
  { id: 24, imgurlMobile: "/u/cms/www/202108/31014138tE4g.jpg" },
  { id: 25, imgurlMobile: "/u/cms/www/202108/31014140Z8m0.jpg" },
  { id: 26, imgurlMobile: "/u/cms/www/202108/31014140y7ow.jpg" },
  { id: 27, imgurlMobile: "/u/cms/www/202108/31014142R884.jpg" },
  { id: 28, imgurlMobile: "/u/cms/www/202108/31014142r76P.jpg" },
  { id: 29, imgurlMobile: "/u/cms/www/202108/310141438x05.jpg" },
  { id: 30, imgurlMobile: "/u/cms/www/202108/31014146IK41.jpg" },
  { id: 31, imgurlMobile: "/u/cms/www/202108/31014145cON5.jpg" },
  { id: 32, imgurlMobile: "/u/cms/www/202108/3101414577gL.jpg" },
  { id: 33, imgurlMobile: "/u/cms/www/202108/31014147142J.jpg" },
  { id: 34, imgurlMobile: "/u/cms/www/202108/31014147Y7LC.jpg" },
  { id: 35, imgurlMobile: "/u/cms/www/202108/31014148655W.jpg" },
  { id: 36, imgurlMobile: "/u/cms/www/202108/31014148FQN0.jpg" },
  { id: 37, imgurlMobile: "/u/cms/www/202108/31014151Z5Ge.jpg" },
  { id: 38, imgurlMobile: "/u/cms/www/202108/31014150g12o.jpg" },
  { id: 39, imgurlMobile: "/u/cms/www/202108/31014152q8Om.jpg" },
  { id: 40, imgurlMobile: "/u/cms/www/202108/3101415234n5.jpg" },
  { id: 41, imgurlMobile: "/u/cms/www/202108/31014158n4to.jpg" },
  { id: 42, imgurlMobile: "/u/cms/www/202108/310141558nEK.jpg" },
  { id: 43, imgurlMobile: "/u/cms/www/202108/3101415813UF.jpg" },
  { id: 44, imgurlMobile: "/u/cms/www/202108/31014159SB17.jpg" },
  { id: 45, imgurlMobile: "/u/cms/www/202108/310142020Z40.jpg" },
  { id: 46, imgurlMobile: "/u/cms/www/202108/3101420169mG.jpg" },
  { id: 47, imgurlMobile: "/u/cms/www/202108/3101420030px.jpg" },
  { id: 48, imgurlMobile: "/u/cms/www/202108/31014202732M.jpg" },
  { id: 49, imgurlMobile: "/u/cms/www/202108/31014204cVuG.jpg" },
  { id: 50, imgurlMobile: "/u/cms/www/202108/310142043407.jpg" },
  { id: 51, imgurlMobile: "/u/cms/www/202108/3101431333nd.jpg" },
  { id: 52, imgurlMobile: "/u/cms/www/202108/31014316taN9.jpg" },
  { id: 53, imgurlMobile: "/u/cms/www/202108/31014314Telz.jpg" },
  { id: 54, imgurlMobile: "/u/cms/www/202108/31014314p894.jpg" },
  { id: 55, imgurlMobile: "/u/cms/www/202108/31014315T34W.jpg" },
  { id: 56, imgurlMobile: "/u/cms/www/202108/3101431799v2.jpg" },
  { id: 57, imgurlMobile: "/u/cms/www/202108/31014318476h.jpg" },
  { id: 58, imgurlMobile: "/u/cms/www/202108/31014320919R.jpg" },
  { id: 59, imgurlMobile: "/u/cms/www/202108/310143224909.jpg" },
  { id: 60, imgurlMobile: "/u/cms/www/202108/310143204y98.jpg" },
  { id: 61, imgurlMobile: "/u/cms/www/202108/3101432291y5.jpg" },
  { id: 62, imgurlMobile: "/u/cms/www/202108/31014323N708.jpg" },
  { id: 63, imgurlMobile: "/u/cms/www/202108/31014324687f.jpg" },
  { id: 64, imgurlMobile: "/u/cms/www/202108/31014324Wp2N.jpg" },
  { id: 65, imgurlMobile: "/u/cms/www/202108/31014326e77l.jpg" },
  { id: 66, imgurlMobile: "/u/cms/www/202108/31014328R715.jpg" },
  { id: 67, imgurlMobile: "/u/cms/www/202108/31014327ZGvz.jpg" },
  { id: 68, imgurlMobile: "/u/cms/www/202108/31014329xFJA.jpg" },
  { id: 69, imgurlMobile: "/u/cms/www/202108/31014334pkI9.jpg" },
  { id: 70, imgurlMobile: "/u/cms/www/202108/310143310R46.jpg" },
  { id: 71, imgurlMobile: "/u/cms/www/202108/31014331Mk8t.jpg" },
  { id: 72, imgurlMobile: "/u/cms/www/202108/310143320Uq6.jpg" },
  { id: 73, imgurlMobile: "/u/cms/www/202108/310143334xWC.jpg" },
  { id: 74, imgurlMobile: "/u/cms/www/202108/31014334494x.jpg" },
  { id: 75, imgurlMobile: "/u/cms/www/202108/31014336Z802.jpg" },
  { id: 76, imgurlMobile: "/u/cms/www/202108/31014336o098.jpg" },
  { id: 77, imgurlMobile: "/u/cms/www/202108/3101434075j5.jpg" },
  { id: 78, imgurlMobile: "/u/cms/www/202108/3101433828cb.jpg" },
  { id: 79, imgurlMobile: "/u/cms/www/202108/31014343o61m.jpg" },
  { id: 80, imgurlMobile: "/u/cms/www/202108/31014341K63d.jpg" },
  { id: 81, imgurlMobile: "/u/cms/www/202108/3101434259G6.jpg" },
  { id: 82, imgurlMobile: "/u/cms/www/202108/31014346yFaD.jpg" },
  { id: 83, imgurlMobile: "/u/cms/www/202108/31014349F4qr.jpg" },
  { id: 84, imgurlMobile: "/u/cms/www/202108/310143571Y15.jpg" },
  { id: 85, imgurlMobile: "/u/cms/www/202108/31014348512N.jpg" },
  { id: 86, imgurlMobile: "/u/cms/www/202108/310143499918.jpg" },
  { id: 87, imgurlMobile: "/u/cms/www/202108/3101435218zy.jpg" },
  { id: 88, imgurlMobile: "/u/cms/www/202108/3101435283p9.jpg" },
  { id: 89, imgurlMobile: "/u/cms/www/202108/310143549ejC.jpg" },
  { id: 90, imgurlMobile: "/u/cms/www/202108/31014400818R.jpg" },
  { id: 91, imgurlMobile: "/u/cms/www/202108/310143577452.jpg" },
  { id: 92, imgurlMobile: "/u/cms/www/202108/31014359145j.jpg" },
  { id: 93, imgurlMobile: "/u/cms/www/202108/31014359DiD1.jpg" },
  { id: 94, imgurlMobile: "/u/cms/www/202108/310144017M3Y.jpg" },
  { id: 95, imgurlMobile: "/u/cms/www/202108/31014400n954.jpg" },
];
let workspace60 = [];
let workspace60big = [];
let workspace60bigMobile = [];
for (let i = 0; i < 18; i++) {
  let arr = [];
  for (let j = 0; j < 5; j++) {
    let element = `${csvw_url}${template60[i * 5 + j].imgurl}`;
    let elementbig = `${csvw_url}${template60[i * 5 + j].imgurlMobile}`;
    let elementbigMobile = `${csvw_url}${
      template60Mobile[i * 5 + j].imgurlMobile
    }`;
    arr.push(element);
    workspace60big.push(elementbig);
    workspace60bigMobile.push(elementbigMobile);
  }
  workspace60.push(arr);
}
console.log(workspace60);
console.log(workspace60big);

let workspace70 = [
  {
    id: 1,
    title: "懂车帝",
    url: "https://www.dongchedi.com/article/7001442641645011470?zt=m_station",
    content:
      "ID.3车尾造型圆润，并且尾门进行了黑化处理，从而整体展现出更强的层次感。",
    imgurl: "/u/cms/www/202108/31000845EfqZ.jpg",
  },
  {
    id: 2,
    title: "易车",
    url: "https://new.qq.com/rain/a/20210829A03AY200",
    content: "ID.3定位于紧凑级两厢轿车，整体造型走的是简洁前卫的设计路线。",
    imgurl: "/u/cms/www/202108/31000845s0Ir.jpg",
  },
  {
    id: 3,
    title: "网通社",
    url: "https://news.yiche.com/hao/wenzhang/52296641",
    content:
      "ID.3采用极具未来感的设计风格，封闭式前脸造型极为简约。头灯采用LED光源且下方日间行车灯与格栅底部银色饰条相连，营造出非常科幻的氛围。",
    imgurl: "/u/cms/www/202108/31000845wqom.jpg",
  },
  {
    id: 4,
    title: "太平洋汽车网",
    url: "https://www.pcauto.com.cn/jxwd/2877/28770268.html",
    content:
      "ID.3搭载最大功率为125kW的驱动电机，峰值扭矩310N·m，而电子限速160km/h。",
    imgurl: "/u/cms/www/202108/31000845575F.jpg",
  },
  {
    id: 5,
    title: "新浪汽车",
    url:
      "https://auto.sina.com.cn/newcar/x/2021-08-29/detail-iktzscyx1057672.shtml",
    content: "ID.3搭载57.3kWh电池组，续航里程为430km。",
    imgurl: "/u/cms/www/202108/31000846nnK7.jpg",
  },
  {
    id: 6,
    title: "网易汽车",
    url: "https://mini.eastday.com/nsa/210829103635365140766.html",
    content:
      "ID.3内饰采用了和车身颜色同风格，电子挡把连为一体的液晶仪表可以显示行车参数，多媒体系统带有车联网功能。",
    imgurl: "/u/cms/www/202108/31000846712i.jpg",
  },
  {
    id: 7,
    title: "搜狐汽车",
    url: "https://m.sohu.com/a/486397911_383324/?pvid=000115_3w_a",
    content: "ID.3长宽高为4261/1778/1568mm，轴距为2765mm。",
    imgurl: "/u/cms/www/202108/31000845ZcVq.jpg",
  },
  {
    id: 8,
    title: "凤凰网汽车",
    url: "https://auto.ifeng.com/c/896dg5qTvEJ",
    content: "ID.3长轴距、短前后悬的设计，舒展侧身造型的同时更显年轻运动。",
    imgurl: "/u/cms/www/202108/310008478CXg.jpg",
  },
  // {
  //   id: 9,
  //   title: "水滴汽车",
  //   url: "http://www.myzaker.com/article/612a2d797f780b5637000002",
  //   content:
  //     "ID.3提供 PURE、PRO、1ST 三种配置车型，都将搭载一台最大功率 125kW 的后置电动机，最大扭矩为 310N · m。",
  //   imgurl: "/u/cms/www/202108/31000846P1r5.jpg",
  // },
  {
    id: 10,
    title: "网新社Xnews",
    url: "https://a.cheshi.com/news/3354308.html",
    content:
      "ID.3车身侧面线条流畅，配备低风阻轮毂，车尾采用双色设计，更显年轻时尚。",
    imgurl: "/u/cms/www/202108/310008462308.jpg",
  },
  {
    id: 11,
    title: "HD说车",
    url: "https://news.yiche.com/hao/wenzhang/52320740",
    content:
      "ID.3车内整体内饰采用简约的设计风格，作为一款新能源车，新车内部极具未来感。",
    imgurl: "/u/cms/www/202108/310008479dH1.jpg",
  },
  {
    id: 12,
    title: "电动邦",
    url: "https://www.diandong.com/news/157411.html",
    content:
      "ID.3采用了家族化设计语言，封闭式前脸搭配多边形头灯和贯穿式灯带很有辨识度，同时下方外扩式的通风口设计增加了运动气质。",
    imgurl: "/u/cms/www/202108/3100084799b6.jpg",
  },
  {
    id: 13,
    title: "每日车讯cardaily",
    url: "https://www.163.com/dy/article/GIJS8ORK0527IHC2.html#",
    content:
      "ID.3内饰设计展现出年轻的一面，整体中控台造型很简洁，配备与电子挡把连为一体的液晶仪表及悬浮式中控屏。",
    imgurl: "/u/cms/www/202108/3100084741qX.jpg",
  },
  {
    id: 14,
    title: "Nice好车",
    url: "https://www.toutiao.com/w/i1709398014318595/",
    content:
      "ID.3是一款基于大众MEB纯电平台打造的紧凑型两厢轿车，还可选装带LED灯带的前大灯组、贯穿式的前LED日间行车灯。",
    imgurl: "/u/cms/www/202108/31000847jvi6.jpg",
  },
  {
    id: 15,
    title: "电动汽车观察家",
    url: "https://www.sohu.com/a/486524696_100044558",
    content:
      "ID.3全新设计的海星花瓣式轮毂采用双色精车工艺，造型新颖有趣，材质为铝合金材质，更具辨识度。",
    imgurl: "/u/cms/www/202108/31000847ki9w.jpg",
  },
  {
    id: 16,
    title: "第一电动",
    url: "https://www.powerlife.com.cn/25894.html",
    content:
      "ID.3提供极光绿、赛博黄、超导红、离子灰、晶质白5种车身颜色，展现潮流风格。",
    imgurl: "/u/cms/www/202108/31000848t1No.jpg",
  },
  {
    id: 17,
    title: "汽车葫芦圈",
    url: "https://www.sohu.com/a/486477095_495793",
    content:
      "ID.3有ID. Light光语系统、IQ. Light矩阵式前大灯等代表大众ID.系列一贯特点的光语互动科技。",
    imgurl: "/u/cms/www/202108/310008481OJx.jpg",
  },
  {
    id: 18,
    title: "EV视界",
    url: "https://www.evlook.com/news-40486.html",
    content:
      "ID.3拥有一款独特的皓白烁金皮肤包，让环境随车一起染上白金色彩的乐趣，尽显格调与趣味。",
    imgurl: "/u/cms/www/202108/31000848VB21.jpg",
  },
  {
    id: 19,
    title: "汽车时代网",
    url: "https://www.autotimes.com.cn/news/202108/1578254.html",
    content:
      "ID.3得益于同级罕有的后轮驱动，ID.3在加速时，车辆重心后移，使得后轮获得更多的抓地力，提高了加速性能。",
    imgurl: "/u/cms/www/202108/31000849336y.jpg",
  },
  // {
  //   id: 20,
  //   title: "86车网",
  //   url: "http://www.86che.com/article/enterprise/2021082951736.html",
  //   content:
  //     "ID.3的独立五连杆后悬、50比50重量配比，让驾驶体验处处体现灵巧自如的乐趣。",
  //   imgurl: "/u/cms/www/202108/31000848B7h5.jpg",
  // },
].map((item) => {
  return {
    ...item,
    imgurl: `${csvw_url}${item.imgurl}`,
  };
});
console.log(workspace70);

let workspace71 = [
  {
    id: 1,
    title: "汽车之家",
    url: "https://www.autohome.com.cn/news/202107/1178034.html",
    content:
      "新帕萨特采用全新的前脸设计，而且分为点阵式精工格栅和星空式格栅两种风格。新的格栅与LED前大灯组连为一体，增强前脸的视觉宽度。",
    imgurl: "/u/cms/www/202108/300007448082.jpg",
  },
  {
    id: 2,
    title: "易车",
    url: "http://news.yiche.com/danchedaogou/20210717/0015017031.html",
    content:
      "新帕萨特传统雾灯区域采用了更加动感的三角造型，使得整车更加年轻化。",
    imgurl: "/u/cms/www/202108/300007441Mq3.jpg",
  },
  {
    id: 3,
    title: "爱卡汽车",
    url: "https://newcar.xcar.com.cn/202107/news_2060816_1.html",
    content:
      "新帕萨特最大的变化在于加入了贯穿式尾灯的设计，这套尾灯颇有奥迪“灯厂”的姿态，灯腔内部细节很丰富，点亮后很有辨识度。",
    imgurl: "/u/cms/www/202108/300007449urc.jpg",
  },
  // {
  //   id: 4,
  //   title: "太平洋汽车网",
  //   url: "https://www.sohu.com/a/584291428_121374789",
  //   content:
  //     "新帕萨特上格栅中部新增了贯穿式的 LED灯带，为前脸增添不少的科技感。",
  //   imgurl: "/u/cms/www/202108/300007442S44.jpg",
  // },
  {
    id: 5,
    title: "凤凰网汽车",
    url: "https://auto.ifeng.com/c/896dg5qTvEJ",
    content:
      "新帕萨特全新设计的星空前脸更激进、前卫，点状造型元素的参数化排布，带来了年轻、动感的气息。",
    imgurl: "/u/cms/www/202108/30233033g41v.jpg",
  },
  {
    id: 6,
    title: "搜狐新车",
    url: "https://mini.eastday.com/nsa/210718004425293228936.html",
    content:
      "新帕萨特轮圈使用了18英寸双色花瓣样式，与之搭配的是固特异旗下主打舒适性和操控性的御乘二代系列，前后胎规格均为235/45 R18。",
    imgurl: "/u/cms/www/202108/300007441611.jpg",
  },
  {
    id: 7,
    title: "汽车头条",
    url: "https://hj.pcauto.com.cn/article/871147",
    content:
      "新帕萨特搭载1.4T和2.0T低/高功率发动机，匹配7速双离合变速箱，发动机最大功率分别为150马力、186马力以及220马力。",
    imgurl: "/u/cms/www/202108/300007444n53.jpg",
  },
  {
    id: 8,
    title: "星车场",
    url: "https://chejiahao.autohome.com.cn/info/9077076",
    content:
      "新帕萨特在内饰方面依然采用了较为传统的设计风格，10色氛围灯能够提供一定的氛围感，同时后排空间也较为理想。",
    imgurl: "/u/cms/www/202108/300007463C68.jpg",
  },
  {
    id: 9,
    title: "玩车教授",
    url: "https://hj.pcauto.com.cn/article/888866",
    content:
      "新帕萨特的中控换装了新款造型的多功能方向盘，后排空调控制也升级为触摸式。",
    imgurl: "/u/cms/www/202108/300007459wlA.jpg",
  },
  {
    id: 10,
    title: "阿贵看车",
    url: "https://www.maiche.com/news/detail/2498237.html",
    content:
      "新帕萨特大灯升级成了全Led矩阵式IQ Lihgt灯组，实现了智能优化照明效果。",
    imgurl: "/u/cms/www/202108/30000745bknh.jpg",
  },
  {
    id: 11,
    title: "懂车之道",
    url: "https://cheshihao.cheshi.com/news/541358.html",
    content:
      "新帕萨特的后保险杠，双边共两出的隐藏式排气布局，增强了车辆尾部的整体感。",
    imgurl: "/u/cms/www/202108/30000745x1PV.jpg",
  },
  {
    id: 12,
    title: "引擎",
    // url: "https://hj.pcauto.com.cn/article/879016",
    url: "https://baijiahao.baidu.com/s?id=1705710961849464433&wfr=spider&for=pc",
    content:
      "新帕萨特沿用多辐条进气格栅设计，并且进气格栅内部镀铬饰条数量增加，呈矩阵式水平排列。",
    imgurl: "/u/cms/www/202108/300007454997.jpg",
  },
  {
    id: 13,
    title: "侃车家",
    url: "https://hj.pcauto.com.cn/article/885804",
    content:
      "新帕萨特车尾变化非常明显，全新设计的贯穿尾灯内部由多根横条灯带组成，层次感非常强，也让我们看到了在电气化时代，大众燃油车的外观风格也将全面跟进新能源车。",
    imgurl: "/u/cms/www/202108/3000074514TI.jpg",
  },
  {
    id: 14,
    title: "車市风云",
    url: "https://ishare.ifeng.com/c/s/88Oy2XDywVd",
    content:
      "新帕萨特车身线条依旧是黄金比例，看起来非常优雅。尾灯与双腰线完美连接，也为侧面增添了力量感。",
    imgurl: "/u/cms/www/202108/300007457N0I.jpg",
  },
  {
    id: 15,
    title: "强子说车",
    url: "https://chejiahao.autohome.com.cn/info/9107872#pvareaid=28086821202",
    content:
      "新帕萨特装配的尺寸达到18英寸的铝合金轮毂的造型看上去既稳重又不失精致感，与整台车高雅精致的气质相融相和。",
    imgurl: "/u/cms/www/202108/30000746627i.jpg",
  },
  {
    id: 16,
    title: "汽车大事记",
    url: "https://hj.pcauto.com.cn/article/871721",
    content:
      "新帕萨特光黑装饰板贯通整个仪表台，将仪表盘和中控显示屏构成一体，营造出贯穿式的视觉感受。",
    imgurl: "/u/cms/www/202108/3000074669Rb.jpg",
  },
  {
    id: 17,
    title: "路遥马力说",
    url: "https://cheshihao.cheshi.com/news/539457.html",
    content:
      "新帕萨特搭载了10.2英寸全液晶仪表和9.2英寸可触控中控屏，支持车联网、CarPlay/CarLife手机互联、语言识别控制系统等功能。",
    imgurl: "/u/cms/www/202108/300007469Tr9.jpg",
  },
  {
    id: 18,
    title: "蜗牛车志",
    url: "https://www.qctt.cn/news/1052398",
    content:
      "新帕萨特部分配置新增了后排航空头枕，侧翼可调节，带来头等舱级的体验。",
    imgurl: "/u/cms/www/202108/30000747g4p0.jpg",
  },
  // {
  //   id: 19,
  //   title: "12缸大师",
  //   url: "https://new.qq.com/omn/20210725/20210725A09PAD00",
  //   content:
  //     "新帕萨特座椅采用了质感很好的高档座椅，乘坐起来对腰背的支撑性十分出色，就算是长时间乘坐也不会觉得疲劳。",
  //   imgurl: "/u/cms/www/202108/300007479s92.jpg",
  // },
  {
    id: 20,
    title: "百一购车班",
    url: "https://chejiahao.autohome.com.cn/info/9166109",
    content:
      "新帕萨特最大的亮点就是采用了双脸设计。同一款车，采用了两个不同的前脸，分别是星空前脸和点阵前脸。",
    imgurl: "/u/cms/www/202108/30000747Twc8.jpg",
  },
  {
    id: 21,
    title: "纽北Turbo哥",
    url: "http://www.sohu.com/a/479517054_100160454",
    content:
      "新帕萨特两侧的大灯组比较纤细，搭配上横向的发光灯带，看起来未来感十足。下格栅底部的镀铬装饰条和两侧C字型饰条贯穿在一起，看起来质感更强烈。",
    imgurl: "/u/cms/www/202108/300007476428.jpg",
  },
  // {
  //   id: 22,
  //   title: "路哥说车",
  //   // url: "https://www.sohu.com/a/478395505_121091002",
  //   content:
  //     "新帕萨特的内饰设计在诸多细节中注入时尚元素，车内配备哈曼卡顿高级音响系统、手机无线充电等功能。",
  //   imgurl: "/u/cms/www/202108/300007487bT3.jpg",
  // },
  {
    id: 23,
    title: "Report汽车",
    url: "https://www.youcheyihou.com/news/1194811",
    content:
      "新帕萨特提供黑、白、银、金和蓝5个车身颜色，内饰则有偏向科技的黑色搭配亮金属饰条和偏向商务的棕色两种风格可选。",
    imgurl: "/u/cms/www/202108/300007480zNo.jpg",
  },
  {
    id: 24,
    title: "EV视界",
    url: "https://www.evlook.com/news-40486.html",
    content:
      "新帕萨其中一款点阵式精工格栅前脸，延续了帕萨特家族的经典设计语言，大气优雅依旧。",
    imgurl: "/u/cms/www/202108/302330337694.jpg",
  },
  {
    id: 25,
    title: "汽车时代网",
    url: "https://www.autotimes.com.cn/news/202108/1578254.html",
    content:
      "新帕萨搭载Travel Assist全旅程智能驾驶辅助系统，以ACC高级自适应定速巡航为例，可实现全速域的道内巡航。",
    imgurl: "/u/cms/www/202108/302330337c15.jpg",
  },
  {
    id: 26,
    title: "中国汽车消费网",
    url: "https://chejiahao.autohome.com.cn/info/9085103#pvareaid=6826274",
    content:
      "新帕萨特长宽高分别为4948/1836/1469mm，轴距2871mm，其车身长度比现款略有增加（+15mm）。",
    imgurl: "/u/cms/www/202108/30000748jb19.jpg",
  },
  // {
  //   id: 27,
  //   title: "86车网",
  //   url: "http://www.86che.com/article/enterprise/2021082951736.html",
  //   content:
  //     "新帕萨实用的手机无线充电功能，轻松摆脱充电线困扰，再无手机电量焦虑。",
  //   imgurl: "/u/cms/www/202108/302330334991.jpg",
  // },
].map((item) => {
  return {
    ...item,
    imgurl: `${csvw_url}${item.imgurl}`,
  };
});

let workspace72 = [
  {
    id: 1,
    title: "网通社",
    url: "http://auto.news18a.com/news/storys_156242.html",
    content:
      "新途观L车尾部分做出了细微的调整，后保险杠处的贯穿式红色反光饰条的融入看上去更精致一些。",
    imgurl: "/u/cms/www/202108/302125510e2M.jpg",
  },
  {
    id: 2,
    title: "爱卡汽车",
    url: "https://drive.xcar.com.cn/202107/news_2061066_1.html",
    content:
      "新途观L的长宽高分别为4735/1859/1677毫米，轴距2791毫米，相比现款车型来说，车长增加了23毫米。",
    imgurl: "/u/cms/www/202108/302125514842.jpg",
  },
  {
    id: 3,
    title: "新浪汽车",
    url:
      "https://auto.sina.cn/review/tiyan/2021-08-02/detail-ikqciyzk8895796.d.html?from=wap",
    content:
      "新途观L推出了5座、7座版本，在7座版本上，第三排座椅可以分别放倒，翻开一边后，后备箱还可以放下三个登机箱以及3-4个书包。",
    imgurl: "/u/cms/www/202108/300013598ui1.jpg",
  },
  {
    id: 4,
    title: "搜狐汽车",
    url: "https://www.sohu.com/a/480757868_430526",
    content:
      "新途观L采用代号DQ381的7速湿式双离合器变速箱，这台变速箱的换挡速度自然是没得挑，换挡逻辑也比较聪明。",
    imgurl: "/u/cms/www/202108/302125511818.jpg",
  },
  {
    id: 5,
    title: "凤凰网汽车",
    url: "https://auto.ifeng.com/c/896dg5qTvEJ",
    content:
      "新途观L焕然一新的运动造型，搭配R-Line套件和双拼色轮毂，将整车运动气息拉满。",
    imgurl: "/u/cms/www/202108/30233215HR84.jpg",
  },
  {
    id: 6,
    title: "此地无垠王垠",
    url: "http://news.yiche.com/hao/wenzhang/50699970",
    content:
      "新途观L在外观上增加了全新的天境蓝、超导红、疾风黄3种车身涂装，不仅让这款中型SUV车型具有了个性化色彩，更让它充满了年轻朝气的漂亮外观。",
    imgurl: "/u/cms/www/202108/300014051P8o.jpg",
  },
  {
    id: 7,
    title: "58汽车",
    url: "https://m.58che.com/info/2407305.html",
    content:
      "新途观L横幅式进气格栅中间融入了一整条LED灯带，完美与两侧灯组相融合，在右侧还配有R的专属字标，相当有辨识度。",
    imgurl: "/u/cms/www/202108/300014001XD4.jpg",
  },
  {
    id: 8,
    title: "众车网",
    url: "https://www.zhongche.com/news/255074.html",
    content:
      "新途观L采用了Matrix矩阵式大灯，可以控制每一颗LED灯珠来实现精准照明，能够有效提升夜间行车的安全性。",
    imgurl: "/u/cms/www/202108/3000140093oT.jpg",
  },
  {
    id: 9,
    title: "牛车网",
    url: "http://www.niuche.com/news/detail_525012.html",
    content:
      "新途观L具备Travel Assist 全旅程智能驾驶辅助系统，配置包含ACC自适应定速巡航、PLA3.0智能泊车辅助系统、BSD盲区监测系统、碰撞警告系统、车道保持系统、疲劳监测等功能。",
    imgurl: "/u/cms/www/202108/30001400C60p.jpg",
  },
  // {
  //   id: 10,
  //   title: "爱买车",
  //   url: "https://auto.gasgoo.com/a/70266929.html",
  //   content:
  //     "新途观L车辆的转向手感和转向力度调校得偏舒适，不会令驾驶者有激烈驾驶的欲望，整体的上手难度不高。",
  //   imgurl: "/u/cms/www/202108/30001402N033.jpg",
  // },
  {
    id: 11,
    title: "一点汽车",
    url: "http://www.yidianzixun.com/article/0WIRcWm6",
    content:
      "新途观L的转向在不同的速度和驾驶模式下有不同的手感，低速时轻巧，在运动模式下和高速时则会变得沉稳一些。",
    imgurl: "/u/cms/www/202108/300014019Dtt.jpg",
  },
  {
    id: 12,
    title: "汽车葫芦圈",
    url: "https://www.sohu.com/a/486477095_495793",
    content:
      "新途观L的Lane Assist车道保持系统可以提示车辆即将偏离车道，并主动修正方向，降低越线风险，让车主行驶之路更加安心。",
    imgurl: "/u/cms/www/202108/30233216J8C5.jpg",
  },
  {
    id: 13,
    title: "汽车评中评",
    url: "https://www.163.com/dy/article/GGJ541CT0527E2PV.html",
    content:
      "新途观L增加了外后视镜迎宾光毯和30色LED环境氛围灯，高配车型还换装了哈曼卡顿高级音响，全系车型都采用了最新式的电容感应多功能触控方向盘。",
    imgurl: "/u/cms/www/202108/30001402QT2G.jpg",
  },
  {
    id: 14,
    title: "引擎密码",
    url: "https://www.163.com/dy/article/GGGNS7BC05279PH1.html",
    content:
      "新途观L 12英寸悬浮式中控屏、30色氛围灯，科技感与舒适性并存。棕、米相拼的内饰色调，淡雅中透露着低调的高级感。",
    imgurl: "/u/cms/www/202108/300014024642.jpg",
  },
  {
    id: 15,
    title: "苑叔聊车",
    url: "https://chejiahao.autohome.com.cn/info/9165535",
    content:
      "新途观L车机系统使用了目前大众最新的智慧车联系统，除了支持在线音乐、在线导航等功能之外，语音识别功能的表现也很不错，识别率挺高的。",
    imgurl: "/u/cms/www/202108/30001404c235.jpg",
  },
  {
    id: 16,
    title: "车界慢慢弹",
    url: "https://chejiahao.autohome.com.cn/info/9173734#pvareaid=6826274",
    content:
      "新途观L提速快、操控准、变道非常果断，配合四驱转向也非常稳定，悬架进程和机械素质依然有非常浓厚的德系味道。",
    imgurl: "/u/cms/www/202108/300014045669.jpg",
  },
  {
    id: 17,
    title: "80君的汽车视野",
    url: "https://auto.ifeng.com/c/88LT4CNULwT",
    content:
      "新途观L的全旅程智能驾驶辅助系统，搭载的系统芯片能达到每秒超2.5万亿次浮点的运算能力，毫秒间精准计算海量信息，让车主在日常行车中体验智能科技提升带来的便利。",
    imgurl: "/u/cms/www/202108/30001404cWi8.jpg",
  },
  {
    id: 18,
    title: "北环爱好者之家",
    url: "https://www.toutiao.com/i6991344692747076099/",
    content:
      "新途观L四驱车型还配备了四种驾驶模式，可以在公路和四驱之间进行切换，旋钮从左到右分别是雪地、公路、越野、个性越野，能够满足各种路况的驾驶需求。",
    imgurl: "/u/cms/www/202108/30001404U401.jpg",
  },
  {
    id: 19,
    title: "汽车鹏友",
    url:
      "https://baijiahao.baidu.com/s?id=1706941323624584892&wfr=spider&for=pc&sa=vs_ob_realtime",
    content:
      "新途观L 12英寸的超大中控屏幕与10.1英寸的液晶仪表构成了人机交互的核心组件，整个中控台采用贯穿设计，空调是隐藏式，看起来整洁大方。",
    imgurl: "/u/cms/www/202108/300014043K92.jpg",
  },
  {
    id: 20,
    title: "车主必读",
    url: "http://www.chezhubidu.com/detail/732866",
    content:
      "新途观L共2种内饰配色，采用了全新设计与布局，在内饰用料和做工以及缝线配色上非常用心。",
    imgurl: "/u/cms/www/202108/30001405ou53.jpg",
  },
  {
    id: 21,
    title: "车主之友",
    url: "https://www.sohu.com/a/481044687_121119177",
    content:
      "新途观L方向盘，采用了大众最新的造型，带点平底效果，底部还有R标识，看上去很运动，多功能按键都采用静电感应式物理按键，美观且反馈感强。",
    imgurl: "/u/cms/www/202108/30001406mFHI.jpg",
  },
  {
    id: 22,
    title: "车叫兽",
    url: "https://www.163.com/dy/article/GGNLOKN80527A52S.html",
    content:
      "新途观L全新IQ. Light 全LED矩阵式前大灯，锐利且颇具智慧的双眸，动感的高光黑下进气格栅配合两侧C型镀铬饰条。",
    imgurl: "/u/cms/www/202108/30001405M20G.jpg",
  },
  {
    id: 23,
    title: "EV视界",
    url: "https://www.evlook.com/news-40486.html",
    content:
      "新途观L配备IQ与颜值兼具12英寸悬浮式中控屏搭配10.3英寸全数字液晶仪表、先锋感十足的30色LED环境氛围灯、哈曼卡顿高级音响系统，仿佛在车内就可以上演光影视听秀。",
    imgurl: "/u/cms/www/202108/3023321589Wp.jpg",
  },
  {
    id: 24,
    title: "汽车时代网",
    url: "https://www.autotimes.com.cn/news/202108/1578254.html",
    content:
      "新途观L的Travel Assist全旅程智能驾驶辅助系统可以实现0-160km/h速度范围内均可全速域驾驶辅助。",
    imgurl: "/u/cms/www/202108/302332166B2F.jpg",
  },
  {
    id: 25,
    title: "四川新闻网",
    url: "http://scauto.newssc.org/system/20210804/003176318.html",
    content:
      "新途观L综合实力都得到了全面提升，搭载的第三代EA888发动机，最大功率为162kW，峰值扭矩为350N·m，驾驶起来依旧“德味”十足。",
    imgurl: "/u/cms/www/202108/30001406Kn30.jpg",
  },
  {
    id: 26,
    title: "邱小铖",
    url: "https://baijiahao.baidu.com/s?id=1707142890187846860&wfr=spider&for=pc",
    content:
      "新途观L Front Assist碰撞警告系统的配备，能够在探测到前方有碰撞风险的情况下，系统自动干预，主动制动，让老司机们更加省心。",
    imgurl: "/u/cms/www/202108/30001407jflx.jpg",
  },
  {
    id: 27,
    title: "auto欣说",
    url: "https://hj.pcauto.com.cn/article/902252",
    content:
      "新途观L扑面而来的摩卡棕、米白以及少量黑色等三色相间的浅内饰布局，配以红色车线点缀其间，美观大方，目之所及，都是满满的高级感。",
    imgurl: "/u/cms/www/202108/30001407d7k7.jpg",
  },
  {
    id: 28,
    title: "Freecar",
    url:
      "http://mp.weixin.qq.com/s?__biz=MzA3Njc4MzE4Mw==&mid=2652177219&idx=1&sn=fab29d7f2ae5445e1016aaab75affe4d#ocr",
    content:
      "新途观L兼备顶尖驾驶辅助配置及安全科技于一身，带来智能、便捷、安全新体验。",
    imgurl: "/u/cms/www/202108/300014073G48.jpg",
  },
].map((item) => {
  return {
    ...item,
    imgurl: `${csvw_url}${item.imgurl}`,
  };
});
export default {
  // 列表
  workspace4: [
    {
      title: "全新纯电ID.3首秀 上汽大众大众品牌集体打卡2021成都车展",
      content:
        "第二十四届成都车展在中国西部国际博览城正式启动。2号馆，上汽大众第三款MEB平台纯电动车ID.3迎来首秀，丰富了ID.家族产品矩阵，并正式启动预订。",
      imgurl: `${csvw_url}/u/cms/www/202108/30115919ID6u.jpg`,
      imgurlMobile: `${csvw_url}/u/cms/www/202108/30115919ID6u.jpg`,
      url:
        "https://www.csvw.com/csvw-website/news/company-news.html?newsid=3136",
    },
    {
      title: "科技豪华格调再进阶 上汽奥迪携重磅车型亮相2021成都车展",
      content:
        "8月29日，上汽奥迪携旗下两款重磅车型亮相2021成都国际车展。作为备受瞩目的上汽奥迪豪华旗舰车型，全新奥迪A7L先行版在西南地区首次正式亮相。",
      imgurl: `${csvw_url}/u/cms/www/202108/30115920I3ED.jpg`,
      imgurlMobile: `${csvw_url}/u/cms/www/202108/30115920I3ED.jpg`,
      url:
        "https://www.csvw.com/csvw-website/news/company-news.html?newsid=3137",
    },
    {
      title: "2021成都车展“麻辣鲜香” 斯柯达全新明锐PRO来添味",
      content:
        "8月29日，第二十四届成都国际车展开幕。各品牌新车、重磅车型纷纷亮相，本届车展可谓“麻辣鲜香”。哪一款车型是你的心头好？",
      imgurl: `${csvw_url}/u/cms/www/202108/301159207251.jpg`,
      imgurlMobile: `${csvw_url}/u/cms/www/202108/301159207251.jpg`,
      url:
        "https://www.csvw.com/csvw-website/news/company-news.html?newsid=3138",
    },
  ],
  // 亮点车型
  workspace5: [
    {
      title: "ID.3",
      content:
        "ID.3是大众集团推出的首款基于MEB平台的纯电动车，定位于打造品质与乐趣兼具的纯电跨界车，在潮趣、智趣、驾趣多方面将乐趣拉满的同时拥有德系安全品质。",
      imgurl: require("../../assets/exhibition-cd24th/imgs/tu2@2x.png"),
      imgurlMobile: require("../../assets/exhibition-cd24th/imgsMobile/tu2@2x.png"),
      videourl: csvw_url + "/u/cms/www/202104/27153247ydRT.mp4",
      url:
        "https://www.csvw.com/svwmedia-website/media/teramont.html?contentId=25121",
    },
    {
      title: "New Passat 新帕萨特",
      content:
        "New Passat新帕萨特将科技与美学完美融合，提供两款前脸造型供消费者选择，外观、内饰、科技等多维度革新，是一款重新定义经典与时尚的魅力之作。",
      imgurl: require("../../assets/exhibition-cd24th/imgs/tu3@2x.png"),
      imgurlMobile: require("../../assets/exhibition-cd24th/imgsMobile/tu3@2x.png"),
      videourl: csvw_url + "/u/cms/www/202104/261457040660.mp4",
      url: "https://www.csvw.com/subject/passat",
    },
    {
      title: "New Tiguan L 新途观L",
      content:
        "新途观L以更新潮动感的设计、强劲卓越的动力组合及更前瞻的智能科技，展现出德系智能中型SUV的魅力。",
      imgurl: require("../../assets/exhibition-cd24th/imgs/tu4@2x.png"),
      imgurlMobile: require("../../assets/exhibition-cd24th/imgsMobile/tu4@2x.png"),
      videourl: csvw_url + "/u/cms/www/202104/26145737R036.mp4",
      url: "https://www.csvw.com/subject/tiguan",
    },
  ],
  // 现场花絮
  workspace6: [
    {
      title: "3号馆",
      key: "workspace60",
    },
  ],
  workspace60: workspace60,
  workspace60big: workspace60big,
  workspace60bigMobile: workspace60bigMobile,
  // 新车赏析
  workspace7: [
    {
      title: "ID.3",
      key: "workspace70",
    },
    {
      title: "新帕萨特",
      key: "workspace71",
    },
    {
      title: "新途观L",
      key: "workspace72",
    },
  ],

  // ID.3
  workspace70: workspace70,

  // 新帕萨特
  workspace71: workspace71,

  // 新途观L
  workspace72: workspace72,
};
